// Classes.
import { BaseComponentLocator } from './base.component-locator';
import { BaseLocator } from './base.locator';


export class DivisionCategoryListLocator extends BaseLocator {
  constructor() {
    super('divisionCategory');
  }
}

